import { SingleValue } from "react-select"
import { BinInfo } from "../staticInfo/state"


export type EnquiryFormInfoState = {  
    district_id:string
    // fileList is only for upload enquiry imgae
    fileList: File[]|null
    // enquiryImage is only for display Image from enquiry 
    enquiryImage:EnquiryImage[] | null
    // to do decide enquiry i,mage

    selectDate:moment.Moment | Date |null;
    selectEnquiry_type_id:string
    case_no:string
    binInfo:SingleValue<BinInfo> | null
    area_id:string
    othersRemark:string
    EnquiryList?:EnquiryFormList[]
    is_others: boolean;
    is_overfilled: boolean;
    need_inspection:string
    selectedEnquiry:boolean
    have_missed_call:string
    have_voice_message:string
    voice_message:string
    get_back_date:moment.Moment | Date |null;
    is_inspected:string | null
    handle_date:moment.Moment | Date |null;
    clearing_date:moment.Moment | Date |null;
    reply_date:moment.Moment | Date |null;
    result:string
    name:string,
    email:string,
    tel:string|null
    enquiry_id?:number
    disclaimer?:boolean
    excelDownloadStartDate:moment.Moment | Date |null;
    excelDownloadEndDate:moment.Moment | Date |null;
}


export type EnquiryImage ={
    image:string|null
    image_thumb:string|null
}


export type EnquiryFormList = {
    enquiry_id: number;
    enquiry_date: string;
    enquiry_type_id: number;
    case_no: string;
    bin_id: number;
    area_id: number;
    district_id: number;
    image: null;
    image_thumb: null;
    is_others: number;
    is_overfilled: number;
    need_inspection: number;
    others_remarks: null;
    is_fetched: number;
    fetched_by: number;
    enquiry_type: string;
    area_cn: string;
    district_cn: string;
    bin_full_name: string;
    is_inspected:number | null

    cs_handle_date:string;
    cs_action:string
    clearing_date:string;
    reply_date:string;
    result:string
    name:string,
    email:string,
    tel:string|null
    have_missed_call:string,
    have_voice_message:string,
    voice_message:string
    get_back_date:string
}






export const enquiryFormInfoState:EnquiryFormInfoState={
    district_id:'',
    fileList:null,
    selectDate:null,
    selectEnquiry_type_id:'',
    case_no:'',
    binInfo:null,
    area_id:'',
    othersRemark:'',
    is_others:false,
    is_overfilled:false,
    need_inspection:'',
    selectedEnquiry:false,
    enquiryImage:null,
    have_missed_call:'',
    have_voice_message:'',
    voice_message:'',
    get_back_date:null,
    is_inspected:null,
    handle_date:null,
    clearing_date:null,
    reply_date:null,
    result:"",
    name:"",
    email:"",
    tel:'',
    disclaimer:false,
    excelDownloadStartDate:null,
    excelDownloadEndDate:null
}
